import * as S from "./styles";

import { useState, useEffect } from "react";
import CurrencyFormat from "react-currency-format";
import { Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import ReprocessarPagamento from "../../ReprocessarPagamento";
import BookingsRepository from "../../../repositories/bookingsRepository";
import { useGlobal } from "../../../contexts/globalContext";

import Loader from "../../Loader";
import { useHistory } from "react-router-dom";
import Auth2faModal from "../../Auth2FaModal";
import Passengers from "../../../assets/icons/passengers.svg";
import CarDoors from "../../../assets/icons/carDoors.svg";
import CarBaggage from "../../../assets/icons/carBaggages.svg";
import CarGear from "../../../assets/icons/carGear.svg";
import CarAc from "../../../assets/icons/carAC.svg";

import { ThemeButton } from "../../ThemeButton/styles";

import { format, parseISO } from "date-fns";
import { pt } from "date-fns/locale";
import { safeFormat } from "../../../utils/dateHelpers";

const CarTravelsCard = ({ booking = [], departureDate, arrivalDate, coinAlias }) => {
	let history = useHistory();

	const bookingsRepository = new BookingsRepository();
	const { showAlert } = useGlobal();

	const [openDialogReprocessar, setOpenDialogReprocessar] = useState(false);
	const [openLoader, setOpenLoader] = useState(false);
	const [openModal2fa, setOpenModal2fa] = useState(false);

	const [vehicleDetail, setVehicleDetail] = useState(booking?.vehicleDetail || null);
	const [pickUpDate, setPickUpDate] = useState(booking?.pickUpDate || null);
	const [dropOffDate, setDropOffDate] = useState(booking?.dropOffDate || null);

	useEffect(() => {
		const needsUpdate =
			booking?.vehicleDetail?.additionalInformation === undefined ||
			booking?.vehicleDetail?.fares === undefined;

		if (booking?.locator && needsUpdate) {
			bookingsRepository.getCarBookingDetails(booking.locator)
				.then((res) => {
					const data = res?.data?.data;
					if (!data?.vehicleDetail) return;
					setVehicleDetail((prev) => ({
						...prev,
						...(data.vehicleDetail.additionalInformation?.paidOnDestination && { additionalInformation: data.vehicleDetail.additionalInformation }),
						...(data.vehicleDetail.fares?.length > 0 && { fares: data.vehicleDetail.fares }),
					}));
					if (data?.pickUpDate) setPickUpDate(data.pickUpDate);
					if (data?.dropOffDate) setDropOffDate(data.dropOffDate);
				})
				.catch(() => {});
		}
	}, [booking?.locator]);

	const closeModal2fa = () => setOpenModal2fa(false);

	const onChangeOpenDialogReprocessar = (open) => setOpenDialogReprocessar(open);

	const getStatusTranslate = (status) => {
		switch (status) {
			case 1:
				return "pendente";
			case 2:
				return "emitido";
			case 3:
				return "expirado";
			case 4:
				return "finalizado";
			case 5:
				return "cancelado";
			default:
				break;
		}
	};

	const reprocessar = () => {
		// onChangeOpenDialogReprocessar(true);

		if ((booking.paymentTransaction === null || booking.paymentTransaction === undefined) && booking.cashTotalValue > 0) {
			onChangeOpenDialogReprocessar(true);
		} else {
			setOpenLoader(true);
			bookingsRepository
				.reprocessarPagamento(booking.bookingCode, {})
				.then((res) => {
					setOpenLoader(false);
					sessionStorage.setItem("@bookingCompleted", JSON.stringify(res));
					switch (res.status) {
						case 200:
							history.push("/busca/finalizado");
							break;
						case 201:
							if (res.data.auth2fa) {
								if (res.data.redirectAuth2fa !== null) {
									setOpenLoader(true);
									window.location.replace(res.data.redirectAuth2fa);
								} else {
									setOpenModal2fa(true);
								}
							} else {
								history.push("/busca/finalizado");
							}
							break;
						default:
							break;
					}
				})
				.catch((err) => {
					setOpenLoader(false);
					switch (err?.response?.status) {
						case 400:
							showAlert("Há algo de errado nos seus dados, verifique!");
							break;
						case 401:
							history.push("/session-expires");
							break;
						case 409:
							sessionStorage.setItem("@bookingError", JSON.stringify(err.response.data.error));
							sessionStorage.setItem("reprocessar", JSON.stringify({ reprocessar: true }));
							history.push("/busca/booking-error");
							break;
						case 504:
							sessionStorage.setItem("@bookingError", JSON.stringify("Tempo expirou, tente novamente!"));
							sessionStorage.setItem("reprocessar", JSON.stringify({ reprocessar: true }));
							history.push("/busca/booking-error");
							break;
						default:
							showAlert("error", `Compra não processada, por favor, tente novamente!`);
							break;
					}
				});
		}
	};

	// const cancelarReserva = (locator) => {
	//   bookingsRepository
	//     .cancelBooking(locator)
	//     .then((res) => {
	//       showAlert('success', 'Reserva cancelada');
	//       window.location.reload();
	//     })
	//     .catch((err) => showAlert('error', 'Houve algum erro, tente novamente!'));
	// };

	const reenviarVoucher = (locator) => {
		bookingsRepository
			.reenviarVoucher(locator)
			.then((res) => showAlert("success", "Voucher reenviado, verifique seu e-mail!"))
			.catch((err) => showAlert("error", "Houve algum erro, tente novamente!"));
	};

	const getVehicleDetailByType = (type) => vehicleDetail?.vehicleDetails?.find((d) => d.type === type);

	const parseLuggageLabel = (name) => {
		if (!name) return "";
		const match = name.match(/\d+/);
		if (match) return match[0];
		const wordMap = { uma: "1", um: "1", dois: "2", duas: "2", "três": "3", tres: "3", quatro: "4", cinco: "5" };
		const lower = name.toLowerCase();
		for (const [word, num] of Object.entries(wordMap)) {
			if (lower.startsWith(word)) return num;
		}
		return name;
	};

	const getCompanyImage = (vehicleDetail) => {
		if (vehicleDetail?.rentalCompany?.logo) return vehicleDetail.rentalCompany.logo;
		if (vehicleDetail?.rentalCompany?.name?.toUpperCase() === "LOCALIZA") return "/img/localiza.svg";
		return "https://via.placeholder.com/150";
	};

	return booking.length !== 0 ? (
		<S.BlankCard>
			<ReprocessarPagamento open={openDialogReprocessar} onClose={onChangeOpenDialogReprocessar} booking={booking} />
			<Loader openLoader={openLoader} />
			<Auth2faModal open={openModal2fa} onClose={closeModal2fa} booking={{ data: booking }} type="reprocessar" />
			<S.CardHeader>
				<S.Title>
					Código da reserva: {booking?.bookingCode}
					<span className="subtitle">
						Data da reserva:{" "}
						{booking?.bookingDateStr !== undefined &&
							booking?.bookingDateStr !== "Invalid Date" &&
							safeFormat(booking?.bookingDateStr, "dd/MM/yyyy", {
								locale: pt,
							})}
					</span>
				</S.Title>
				{booking?.statusId && (
					<S.StatusContainer>
						{booking?.statusId === 1 && (
							<ThemeButton className="reprocessar" onClick={reprocessar}>
								Reprocessar Pagamento
							</ThemeButton>
						)}
						{/* {booking?.statusId === 1 &&
              booking?.purchaseId !== null &&
              booking?.purchaseConfirmed === false && (
                <ThemeButton
                  className='reprocessar'
                  onClick={() => cancelarReserva(booking?.bookingCode)}
                >
                  Cancelar reserva
                </ThemeButton>
              )} */}
						{booking?.statusId === 2 && (
							<ThemeButton className="reprocessar" onClick={() => reenviarVoucher(booking?.bookingCode)}>
								Reenviar Voucher
							</ThemeButton>
						)}

						<S.Status className={`status ${getStatusTranslate(booking.statusId)}`}>{getStatusTranslate(booking.statusId)}</S.Status>
					</S.StatusContainer>
				)}
			</S.CardHeader>
			<S.Subtitle>Detalhes da reserva</S.Subtitle>
			<S.CardContent container>
				<S.CarDetails item xs={12}>
					{(vehicleDetail?.images?.[0]?.large || vehicleDetail?.images?.[0]?.standard) && (
						<img className="car-picture" src={vehicleDetail?.images?.[0]?.large || vehicleDetail?.images?.[0]?.standard} alt="Foto do carro" />
					)}
					<div className="car-details1">
						{vehicleDetail?.rentalCompany && (
							<img className="company-logo" src={getCompanyImage(vehicleDetail)} alt={vehicleDetail?.rentalCompany?.name?.toUpperCase()} />
						)}
						<span className="car-type">{vehicleDetail?.class}</span>
						<span className="car-model">{vehicleDetail?.model}</span>
					</div>
					<div className="car-details2">
						<div>
							<div>
								{getVehicleDetailByType("NR_PASSENGER") && (
									<>
										<img src={Passengers} alt="Passageiros" />
										<span>{getVehicleDetailByType("NR_PASSENGER")?.name}</span>
									</>
								)}
							</div>
							<div>
								{getVehicleDetailByType("NR_DOORS") && (
									<>
										<img src={CarDoors} alt="Numero de portas" />
										<span>{getVehicleDetailByType("NR_DOORS")?.name}</span>
									</>
								)}
							</div>
							<div>
								{getVehicleDetailByType("NR_LUGGAGE") && (
									<>
										<img src={CarBaggage} alt="Numero de malas" />
										<span>{parseLuggageLabel(getVehicleDetailByType("NR_LUGGAGE")?.name)}</span>
									</>
								)}
							</div>

							{getVehicleDetailByType("TRANSMISSION") && (
								<div>
									<>
										<img src={CarGear} alt="Cambio" />
										<span>{getVehicleDetailByType("TRANSMISSION")?.name?.toUpperCase()?.includes("AUTO") ? "Auto" : "Man."}</span>
									</>
								</div>
							)}

							{getVehicleDetailByType("AIR_CONDITIONING") && (
								<div>
									<>
										<img src={CarAc} alt="Ar condicionado" />
										<span>AC</span>
									</>
								</div>
							)}
						</div>
					</div>
				</S.CarDetails>
				<S.BottomDetails item xs={12}>
					<div className="place-details">
						<div>
							<span className="hour">
								Retirada {pickUpDate && safeFormat(pickUpDate, "dd/MM/yyyy HH:mm")}
							</span>
							<span className="place">{vehicleDetail?.pickUpLocation?.name}</span>
						</div>
						<div>
							<span className="hour">
								Devolução {dropOffDate && safeFormat(dropOffDate, "dd/MM/yyyy HH:mm")}
							</span>
							<span className="place">{vehicleDetail?.dropOffLocation?.name}</span>
						</div>
					</div>
					{vehicleDetail?.fares?.length > 0 && (() => {
						const tooltipContent = vehicleDetail.fares
							.map((f) => f.description)
							.filter(Boolean)
							.join("<br/>");
						if (!tooltipContent) return null;
						return (
							<div className="fares-notice">
								<span className="fare-name">Detalhes da tarifa</span>
								<Tooltip
									title={<span style={{ fontSize: 12 }} dangerouslySetInnerHTML={{ __html: tooltipContent }} />}
									placement="top"
									arrow
								>
									<InfoOutlinedIcon className="fare-info-icon" style={{ fontSize: 16, cursor: "pointer", color: "#666" }} />
								</Tooltip>
							</div>
						);
					})()}
					{vehicleDetail?.additionalInformation?.paidOnDestination?.price?.amount > 0 && (
						<div className="paid-on-destination-notice">
							<span>
								{vehicleDetail.additionalInformation.paidOnDestination.description || "Valor a ser pago no local de retirada/devolução"}
								{" "}
								<strong>
									<CurrencyFormat
										fixedDecimalScale
										value={vehicleDetail.additionalInformation.paidOnDestination.price.amount}
										displayType="text"
										decimalSeparator=","
										decimalScale={2}
										prefix={`${vehicleDetail.additionalInformation.paidOnDestination.price.currency || "BRL"} `}
									/>
								</strong>
							</span>
						</div>
					)}
					<div className="reservation-details">
						<div>
							{/* <span>{booking?.car?.km === 0 ? 'Km Ilimitado' : booking?.car?.km + ' Kms'}</span> */}
							{/* <span>{booking?.car?.freeCancellation && 'Cancelamento grátis'}</span> */}
						</div>
					</div>
				</S.BottomDetails>
			</S.CardContent>

			<S.BottomInfos>
				{booking.passengers && (
					<S.Travellers>
						<S.Subtitle>VIAJANTES</S.Subtitle>
						{booking.passengers.map((passenger) => (
							<S.TravellerName>{`${passenger.name} ${passenger.lastName}`}</S.TravellerName>
						))}
					</S.Travellers>
				)}
				{!booking.pointsTotalValue && !booking.cashTotalValue && booking?.BookingBySource?.[0]?.TotalFare?.Total && (
					<S.ValorTotal>Total: R$ {booking?.BookingBySource?.[0]?.TotalFare?.Total?.toLocaleString("pt-BR") || "N/A"}</S.ValorTotal>
				)}
				{booking.pointsTotalValue ? (
					<S.ValorTotal>
						Valor em {coinAlias}: {booking.pointsTotalValue}
					</S.ValorTotal>
				) : (
					""
				)}
				{booking.cashTotalValue ? <S.ValorTotal> Valor em R$: {booking.cashTotalValue.toLocaleString("pt-BR")}</S.ValorTotal> : ""}
			</S.BottomInfos>
			{booking.bookingExpirationDate && (
				<S.ExpirationDate>
					{booking.purchaseId !== null && booking.purchaseId !== undefined && (
						<S.Title>
							<span className="subtitle-locator">Locator: {booking.locator}</span>
						</S.Title>
					)}
					{booking.statusId === 1 && (
						<span>
							Esta reserva expira em:{" "}
							{booking?.bookingExpirationDate !== undefined &&
								booking?.bookingExpirationDate !== "Invalid Date" &&
								safeFormat(booking?.bookingExpirationDate, "dd/MM/yyyy HH:mm", {
									locale: pt,
								})}
						</span>
					)}
				</S.ExpirationDate>
			)}
		</S.BlankCard>
	) : (
		<> </>
	);
};

export default CarTravelsCard;
